<!-- <div class="nb-theme-default"> -->
<nb-checkbox [status]="status" (change)="checkstatus()" [checked]="check" [indeterminate]="indeterminate">{{ label }}</nb-checkbox>
<!-- </div> -->